import { useState, useEffect } from 'react'
import { PortalSpinner } from 'components/PortalSpinner'
import { ConversationActions } from 'store/actions'
import Item from './Item'
import { connect } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import toast from 'react-hot-toast'

let enhancer = connect(null, { ...ConversationActions })

const initialParams = {
  q: { title_cont: "" },
  page: 1,
  items: 20
}

function List({ getConversations }) {
  const [conversations, setConversations] = useState(null)
  const [pageEnd, setPageEnd] = useState(false)
  const [params, setParams] = useState(initialParams)

  async function loadConversations(_params = initialParams) {
    try {
      let { data: _conversations = [], pagy } = await getConversations(_params)
      setConversations(_params.page == 1 ? _conversations : [...(conversations ?? []), ..._conversations])
      setParams(_params)
      setPageEnd(!pagy?.next)
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load conversations')
    }
  }

  useEffect(() => {
    loadConversations()
  }, [])

  const handleSearch = (query: string) => {
    loadConversations({ ...initialParams, q: { title_cont: query } })
  }

  const loadMore = () => {
    loadConversations({ ...params, page: params.page + 1 })
  }

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-2">
        <input
          type="text"
          placeholder="Search conversations..."
          defaultValue=""
          onChange={e => handleSearch(e.target.value)}
          className="input input-bordered input-sm w-full"
        />
      </div>

      {conversations === null ? (
        <PortalSpinner size={6} />
      ) : (
        <div id="conversation-list-scroll" className="flex-1 overflow-y-auto">
          <InfiniteScroll
            dataLength={conversations.length}
            next={loadMore}
            hasMore={!pageEnd}
            loader={<PortalSpinner padding="py-3" size={6} />}
            scrollableTarget="conversation-list-scroll"
            className="flex flex-col divide-y divide-base-200"
          >
            {conversations.length === 0 ? (
              <div className="py-12 text-center text-sm text-base-content/40">
                No conversations found.
              </div>
            ) : (
              conversations.map((item: any) => (
                <Item key={`conversation-${item.id}`} item={item} />
              ))
            )}
          </InfiniteScroll>
        </div>
      )}
    </div>
  )
}

export default enhancer(List)
